import React, {useState} from "react"
import Modal from "react-modal"
import closeIcon from "../../assets/img/cross-icon.svg"
import { customModalStyles } from "../utils/styles"

const styles = customModalStyles(20)
styles.content.padding = 0

const CierreDiarioTableModal = ({
  getIcon, 
  mobileDetails, 
  closeMobileDetails
}) => {
  return (
    <Modal isOpen={true} onRequestClose={closeMobileDetails} style={styles}>
      <div className="mobile-filters__title responsive-filters">
        <h1 className="responsive-modal-title">Cierre Diario</h1>
        <button className="mobile-filters__close-btn" onClick={closeMobileDetails}>
          <img src={closeIcon} alt="close modal" />
        </button>
      </div>
      <div className="mobile-filters__main-section">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>Tipo</th>
              <th className="align-center">N° Ticket</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Entradas</td>
              <td className="align-center icon-container">{getIcon(mobileDetails.confirmacion_entrada, 1)} </td>
            </tr>
            <tr>
            <td>Ventas</td>
              <td className="align-center icon-container">{getIcon(mobileDetails.confirmacion_ventas, 2)} </td>
            </tr>
            <tr>
              <td>Calibración y Mov. Bodega</td>
              <td className="align-center icon-container">{getIcon(mobileDetails.calibracion_bodega, 3)}</td>
            </tr>
            <tr>
              <td>Medición Física</td>
              <td className="align-center icon-container">{getIcon(mobileDetails.medicion_fisica, 4)}</td>
            </tr>
            <tr>
              <td>Fluctuaciones</td>
              <td className="align-center icon-container">{getIcon(mobileDetails.cierre_operaciones, 5)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mobile-filters__footer">
        <button className="main-button" onClick={closeMobileDetails}>
          Cerrar
        </button>
      </div>
    </Modal>
  )
}

export default CierreDiarioTableModal
